export default __webpack_public_path__ + "static/media/Group3398@3x.f9b59e1e.png";